export default __webpack_public_path__ + "static/media/her3d.b0bbfae6.png";